import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { HeaderAdministrationSelect } from '~/components/header-administration-select';
import { HeaderBreadcrumb } from '~/components/header-breadcrumb';
import { HeaderGlobalSearch } from '~/components/header-global-search';
import { Sidebar } from '~/components/sidebar';
import { auth } from '~/lib/firebase';

export const Route = createFileRoute('/_authenticated')({
    beforeLoad: async () => {
        await auth.authStateReady();
        if (!auth.currentUser) {
            throw redirect({ to: '/login' });
        }
    },
    component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
    return (
        <div className="flex h-screen overflow-hidden bg-white">
            <div className="border-r border-[#F0F0F0]">
                <Sidebar />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
                <header className="flex h-11 shrink-0 items-center gap-4 border-b border-[#F0F0F0] px-6">
                    <div className="flex flex-1 items-center">
                        <HeaderBreadcrumb />
                    </div>
                    <div className="w-full max-w-md">
                        <HeaderGlobalSearch />
                    </div>
                    <div className="flex flex-1 justify-end">
                        <HeaderAdministrationSelect />
                    </div>
                </header>
                <div className="min-h-0 flex-1 overflow-y-auto [scrollbar-gutter:stable]">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
